/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import braintree from 'braintree-web';
import mbpUtil from 'mbp-api-util';

// Plugin Config
export const venmoPluginConfig = {
    environment: mbpUtil.getEnv('APP_VENMO_ENV'),
    profileId: mbpUtil.getEnv('APP_VENMO_PROFILE_ID'),
};

export const isVenmoMethodSupported = () => braintree?.venmo?.isBrowserSupported();

export default {};
